export const API_NAME = 'invoice';
export const API_VERSION = 'v1';
export const API_BASE_URL = `${API_NAME}/${API_VERSION}`;

export const DEFAULT_ORDER: 'ASC' | 'DESC' = 'ASC';
export const DEFAULT_ROWS = 10;

export const transmitInvoiceDicionaryErrorField: Record<string, string> = {
  'tributos.icms.aliquota': 'ICMS - Aliquota do imposto',
  'tributos.icms.baseCalculo.modalidadeDeterminacao':
    'ICMS - Modalidade de determinação da BC do ICMS',
  'tributos.icms.baseCalculo.valor': 'ICMS - Valor da base de cálculo',
  'tributos.icms.substituicaoTributaria.baseCalculo.modalidadeDeterminacao':
    'ICMS - Modalidade de determinação da BC do ICMS',
  'tributos.icms.substituicaoTributaria.baseCalculo.valor':
    'ICMS - Valor da BC do ICMS ST',
  'tributos.icms.substituicaoTributaria.aliquota': 'ICMS - Aliquota ST',
  'tributos.icms.substituicaoTributaria.fundoCombatePobreza.baseCalculo.valor':
    'ICMS - Valor da Base de Cálculo do FCP retido por Substituição Tributária',
  'tributos.icms.substituicaoTributaria.fundoCombatePobreza.aliquota':
    'ICMS - Valor Alíquota FCP ST (%)',
  'tributos.icms.fundoCombatePobreza.baseCalculo.valor':
    'ICMS - Valor da Base de Cálculo do FCP',
  'tributos.icms.fundoCombatePobreza.aliquota':
    'ICMS - Percentual relativo ao Fundo de Combate à Pobreza (Alíquota)',
  'tributos.pis.cst': 'PIS - CST',
  'tributos.cofins.cst': 'COFINS - CST',
  'tributos.partilha.ufDestino.percentualIcmsFcp':
    'Partilha - Percentual ICMS FCP',
  'tributos.partilha.ufDestino.aliquotaInterna': 'Partilha - Alíquota Interna',
  'tributos.partilha.ufDestino.aliquotaInterestadual':
    'Partilha - Alíquota Interestadual',
  'tributos.icms.baseCalculo.percentualReducao': 'Percentual da Redução de BC',
  'destinatario.indicadorInscricaoEstadual':
    'Destinatário - Inscrição Estadual',
  'codigo': 'Serviço - Código serviços',
  'tomador.indicadorInscricaoEstadual': 'Destinatário - Inscrição Estadual',
  'itens': 'Itens da nota',
  'pagamentos': 'Pagamentos',
  'discriminacao': 'Serviço - ',
  'presencial': 'Operação presencial',
  'natureza': 'Natureza da operação',
  'consumidorFinal': 'Consumidor final',
  'tributos.icms': 'ICMS',
};

export const transmitInvoiceDicionaryErrorValue: Record<string, string> = {
  'Não pode ser um array vazio': 'Informe um item',
  'Falha na validação do JSON de NFe': 'Falha na validação dos dados da NFe',
};

export const consultInvoiceDicionarySuccessMessage: Record<string, string> = {
  'RPS Autorizada com sucesso': 'NFS-e Autorizada',
  'Autorizado o uso da NF-e': 'NF-e Autorizada',
};
